import React from "react";

const LogoSUBEBlanco = ({ className = "h-10 w-auto" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="150.001"
    height="63.369"
    viewBox="0 0 150.001 63.369"
    className={className}
  >
    <g transform="translate(0.001)">
      <path
        d="M716.421,130.046a23.776,23.776,0,0,0-9.365-1.98c-3.163,0-7.252,1.383-7.252,6.4,0,7.978,20.175,4.616,20.175,20.042,0,10.091-7.974,13.914-17.269,13.914-5.014,0-7.255-.656-11.805-1.777l.859-8.31a22.18,22.18,0,0,0,10.415,2.832c3.5,0,8.177-1.781,8.177-5.932,0-8.771-20.178-5.143-20.178-20.373,0-10.289,7.978-14.046,16.089-14.046a34.745,34.745,0,0,1,11.012,1.648Z"
        transform="translate(-690.178 -105.063)"
        fill="#fff"
        fillRule="evenodd"
      />
      <path
        d="M701.019,121.038h9.233v26.574c0,7.845,2.507,12.985,9.56,12.985s9.56-5.139,9.56-12.985V121.038h9.236v29.406c0,12.336-6.99,17.409-18.8,17.409s-18.793-5.073-18.793-17.409Z"
        transform="translate(-663.166 -104.497)"
        fill="#fff"
        fillRule="evenodd"
      />
      <path
        d="M701.019,132.841c.933-.939,12.92-12.783,15.866-15.356a4.067,4.067,0,0,1,5.58-.126l16.142,15.481h-9.236v26.574c0,7.845-2.506,12.985-9.56,12.985s-9.56-5.139-9.56-12.985V132.841Zm16.53,46.748-.137.08-.177-.1Z"
        transform="translate(-663.166 -116.301)"
        fill="rgba(95,123,20,0.81)"
        fillRule="evenodd"
      />
      <path
        d="M723.142,159.808H727.5c4.281,0,9.494-1.051,9.494-6.393,0-6.005-4.878-6.927-9.494-6.927h-4.354v13.32Zm0-20.178H726.9c3.886,0,8.705-.859,8.705-5.6,0-5.342-4.679-5.737-8.9-5.737h-3.562v11.341Zm-9.228-18.593H730c5.932,0,14.832,1.714,14.832,11.8,0,5.468-3.693,9.291-9.161,10.283v.133c6.26.593,10.549,4.811,10.549,10.485,0,11.606-10.415,13.32-16.219,13.32H713.914Z"
        transform="translate(-631.037 -104.497)"
        fill="#fff"
        fillRule="evenodd"
      />
      <path
        d="M725.321,121.038h27.161v7.252H734.554v11.339h16.413v7.254H734.554v12.924h18.062v7.256H725.321Z"
        transform="translate(-602.616 -104.497)"
        fill="#fff"
        fillRule="evenodd"
      />
    </g>
  </svg>
);

export default LogoSUBEBlanco;
